import component from './CombiRoof.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  FormSliderComponentConfig,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';
import i18n from '@/plugins/i18n';
import { buildFormSlider } from '@/lib/forms/builder';

export interface CombiRoofStepContext extends AssistantStepContext {
  roofShape: FormMultipleChoiceValueType;
  roofDirection: FormSliderComponentConfig;
}

const tickLabels: Array<string> = [];

tickLabels[0] = i18n
  .t('combiRoof.formFields.roofDirection.options.west.label')
  .toString();
tickLabels[1] = i18n
  .t('combiRoof.formFields.roofDirection.options.southwest.label')
  .toString();
tickLabels[2] = i18n
  .t('combiRoof.formFields.roofDirection.options.south.label')
  .toString();
tickLabels[3] = i18n
  .t('combiRoof.formFields.roofDirection.options.southeast.label')
  .toString();
tickLabels[4] = i18n
  .t('combiRoof.formFields.roofDirection.options.east.label')
  .toString();

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  isDisabled: (context) =>
    !context.combiInterest?.combiInterest?.includes('pv'),
  fields: [
    {
      component: {
        columns: 3,
        hideCheckbox: true,
        options: [
          {
            value: 'flat-roof',
            image: {
              file: 'img/icon/flat-roof.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'pitched-roof',
            image: {
              file: 'img/icon/pitched-roof.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'peaked-roof',
            image: {
              file: 'img/icon/peaked-roof.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
        outputFormatter: (data) => ({
          formattedLabel: i18n.t(
            'combiRoof.formFields.roofShape.formattedLabel',
          ) as string,
          formattedValue: data?.formattedValue,
        }),
      } as FormMultipleChoiceComponentConfig,
      name: 'roofShape',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.OBJECT,
    },
    buildFormSlider('roofDirection', {
      component: {
        min: 0,
        max: 4,
        thumbLabel: false,
        tickLabels,
        showTicks: false,
        trackColor: '#fabd02',
        trackFillColor: '#fabd02',
        thumbSize: 50,
      },
      outputFormatter: (data) => ({
        formattedLabel: i18n.t(
          'combiRoof.formFields.roofDirection.formattedLabel',
        ) as string,
        formattedValue: tickLabels[data?.formattedValue],
      }),
      groupId: FormFieldGroupId.OBJECT,
    }),
  ],
  id: StepId.COMBI_ROOF,
  categoryId: StepCategoryId.COMBI,
};

export default config;
